/**
 * Hook for managing streaming cursor style preferences
 */

import type { StreamingCursorStyle } from "@/types/user-settings"

import { useGeneralSettings } from "./use-module-settings"

/**
 * Available cursor styles. Display strings live under `settings.streaming_cursor_styles`
 * in the locale files; resolve `nameKey`/`descriptionKey` with `t()` at render time.
 */
export const CURSOR_STYLES = [
  {
    id: "none",
    nameKey: "settings.streaming_cursor_styles.none.name",
    descriptionKey: "settings.streaming_cursor_styles.none.description",
  },
  {
    id: "bar",
    nameKey: "settings.streaming_cursor_styles.bar.name",
    descriptionKey: "settings.streaming_cursor_styles.bar.description",
  },
  {
    id: "block",
    nameKey: "settings.streaming_cursor_styles.block.name",
    descriptionKey: "settings.streaming_cursor_styles.block.description",
  },
  {
    id: "dot",
    nameKey: "settings.streaming_cursor_styles.dot.name",
    descriptionKey: "settings.streaming_cursor_styles.dot.description",
  },
  {
    id: "fade",
    nameKey: "settings.streaming_cursor_styles.fade.name",
    descriptionKey: "settings.streaming_cursor_styles.fade.description",
  },
] as const

export function useStreamingCursor() {
  const { settings, updateSettings } = useGeneralSettings()
  const cursorStyle: StreamingCursorStyle = settings?.streamingCursorStyle ?? "fade"

  const setCursorStyle = (style: StreamingCursorStyle) => {
    void updateSettings({ streamingCursorStyle: style })
  }

  return { cursorStyle, setCursorStyle, cursorStyles: CURSOR_STYLES }
}
